import type { ComponentProps, FC } from "react";
import { NavLink } from "react-router";

import { cn } from "../../utils";
import { AppNavLinkContent, type AppNavLinkContentProps } from "./app-nav-link-content";
import { AppNavTooltip } from "./app-nav-tooltip";

export const appLinkClassName =
  "cursor-pointer block rounded-md text-left text-muted-foreground hover:text-foreground hover:bg-foreground/5 transition-colors w-full ring-offset-background focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50";

export const appLinkCurrentClassName = "aria-[current]:filled aria-[current]:text-primary aria-[current]:bg-primary/10";

export type AppNavLinkProps = ComponentProps<typeof NavLink> & AppNavLinkContentProps & { tooltipHidden?: boolean };

export const AppNavLink: FC<AppNavLinkProps> = ({
  className,
  count,
  icon,
  iconClassName,
  label,
  isLoading,
  tooltipHidden,
  hasChildren,
  ...props
}) => (
  <AppNavTooltip label={label} hidden={tooltipHidden}>
    <NavLink {...props} className={cn(appLinkClassName, appLinkCurrentClassName, className)}>
      <AppNavLinkContent
        count={count}
        icon={icon}
        iconClassName={iconClassName}
        label={label}
        isLoading={isLoading}
        hasChildren={hasChildren}
      />
    </NavLink>
  </AppNavTooltip>
);
